<template>
  <div class="l-empty-holder">
    <template v-if="!useSlot">
      <div v-if="!loading" class="l-empty-visual" aria-hidden="true">
        <img
          v-if="image || tmpl.url"
          class="l-empty-img"
          :src="image || tmpl.url"
          alt=""
        />
        <div v-else class="l-empty-mark">
          <span class="l-empty-mark-line" />
          <span class="l-empty-mark-dot" />
        </div>
      </div>
      <BaseLoading v-if="loading" />
      <span v-if="!loading" class="l-empty-message">
        {{ msg || tmpl.message }}
      </span>
    </template>
    <slot />
  </div>
</template>

<script>
import empty from '@/assets/svg/empty.svg';
import empty_tasks from '@/assets/svg/empty-tasks.svg';
import empty_items from '@/assets/svg/empty-items.svg';
import empty_plans from '@/assets/svg/empty-plans.svg';
import empty_video from '@/assets/svg/empty-video.svg';
import maintaining from '@/assets/svg/maintaining.svg';
import no_acl from '@/assets/svg/no-acl.svg';
import empty_comment from '@/assets/svg/empty-comment.svg';
import empty_content from '@/assets/svg/empty-content.svg';

export default {
  props: ['msg', 'type', 'loading', 'image', 'empty'],
  computed: {
    useSlot() {
      return !!this.$slots.default;
    },
    tmpl() {
      const tmpls = {
        empty: {
          url: empty,
          message: '暂无内容',
        },
        'empty-task': {
          url: empty_tasks,
          message: '暂无任务',
        },
        'empty-item': {
          url: empty_items,
          message: '暂无记录',
        },
        'empty-plan': {
          url: empty_plans,
          message: '暂无计划',
        },
        'empty-video': {
          url: empty_video,
          message: '暂无视频',
        },
        maintaining: {
          url: maintaining,
          message: '维护中',
        },
        'no-acl': {
          url: no_acl,
          message: '暂无权限',
        },
        'empty-comment': {
          url: empty_comment,
          message: '暂无评论',
        },
        'empty-content': {
          url: empty_content,
          message: '暂无内容',
        },
      };
      return tmpls[this.type] || tmpls.empty;
    },
  },
};
</script>

<style lang="less">
.l-empty-holder {
  height: 100%;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  padding: 20px 12px;
  box-sizing: border-box;
  background: transparent;
  border-radius: 6px;
}

.l-empty-visual {
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.55;
}

.l-empty-img {
  width: 96px;
  max-width: 28%;
  max-height: 96px;
  object-fit: contain;
  filter: grayscale(0.35) opacity(0.85);
}

.l-empty-mark {
  position: relative;
  width: 56px;
  height: 40px;
  border: 1px solid var(--border, #e5e7eb);
  border-radius: 8px;
  background: var(--bg2, #f7f8fa);
}

.l-empty-mark-line {
  position: absolute;
  left: 10px;
  right: 10px;
  top: 14px;
  height: 1px;
  background: var(--border, #d9dde3);
  box-shadow: 0 8px 0 var(--border, #d9dde3), 0 16px 0 var(--border, #d9dde3);
}

.l-empty-mark-dot {
  position: absolute;
  right: 10px;
  bottom: 8px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--subtext3, #c0c4cc);
}

.l-empty-message {
  font-size: 13px;
  line-height: 1.5;
  color: var(--subtext2, #909399);
  letter-spacing: 0.02em;
}
</style>
